import React from 'react';
import { MailIcon, GlobeIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="py-8 px-4 bg-chem-navy text-white border-t border-white/5" data-id="element-73" data-mp="3gfiu2hdxs9dl">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-74" data-mp="32oe3e4sjqrfe">
        <div className="mb-8" data-id="element-75" data-mp="36pfsvtwnvp46">
          <span className="text-chem-turquoise font-black tracking-widest text-sm uppercase" data-id="element-76" data-mp="36ooajks2rnvu">
            GUIADIGITAL360 TM
          </span>
          <p className="text-white/45 text-xs mt-2 font-bold uppercase tracking-tighter" data-id="element-77" data-mp="3uftqdzy0mg65">
            Química Visual © {new Date().getFullYear()}
          </p>
        </div>

        <div className="flex gap-6 mb-8" data-id="element-78" data-mp="3ldkcd03jg4o0">
          <a href="#" aria-label="Instagram" className="text-white/50 hover:text-white transition-colors" data-id="element-79" data-mp="3lgomsf7ljwn4">
            <InstagramIcon size={20} data-id="element-80" data-mp="29ydvry6nv08u" />
          </a>
          <a href="#" aria-label="Correo electrónico" className="text-white/50 hover:text-white transition-colors" data-id="element-81" data-mp="2eya0y0r3gxpz">
            <MailIcon size={20} data-id="element-82" data-mp="3l9sjf6xt4wpj" />
          </a>
          <a href="#" aria-label="Sitio web" className="text-white/50 hover:text-white transition-colors" data-id="element-83" data-mp="3gapf5opniuim">
            <GlobeIcon size={20} data-id="element-84" data-mp="3v91bfu944199" />
          </a>
        </div>

        <div className="space-y-2 text-[10px] md:text-xs text-white/40 font-medium max-w-md" data-id="element-85" data-mp="3q8dhazpl74at">
          <p data-id="element-86" data-mp="828lk264fx7k">
            Descargo de responsabilidad: Los resultados pueden variar según cada
            docente, contexto institucional y modalidad de uso. El material es
            de carácter pedagógico y didáctico.
          </p>
        </div>
      </div>
    </footer>;
}